import apiClient from "../utils/apiClient";
import { ErrorDto } from "../types/PortalError";
import { ApiErrorsDto, ErrorLogRequest, PortalErrorsDto } from "../types/ErrorLog";

export const addPortalError = async (ErrorData?: ErrorDto): Promise<number> => {
  const response = await apiClient.post<number>("/Portal/error", ErrorData);
  return response.data;
};

export const getPortalError = async (
  ErrorRequest?: ErrorLogRequest
): Promise<PortalErrorsDto[]> => {
  const response = await apiClient.get<PortalErrorsDto[]>("/portal/error", {
    params: {
      fromDate: ErrorRequest?.fromDate,
      toDate: ErrorRequest?.toDate,
    },
  });
  return response.data;
};

export const getApiError = async (ErrorRequest?: ErrorLogRequest): Promise<ApiErrorsDto[]> => {
  const response = await apiClient.get<ApiErrorsDto[]>("/exception/portal-list", {
    params: {
      fromDate: ErrorRequest?.fromDate,
      toDate: ErrorRequest?.toDate,
      source: ErrorRequest?.source,
    },
  });
  return response.data;
};
